import { articleTypes, exhibitionTypes } from '@/types';
import { createObjectFromArray } from '@/tools/createObjectFromArray';

function getBaseExhibition(landingExhibition, type, languageContentList) {
	return {
		exhibitionID: type,
		type,
		tours: {},
		packages: [],
		packagesWithVersion: [],
		triggers: [],
		articles: [],
		analyticsSiteId: landingExhibition.analyticsSiteId,
		styleTemplateID: landingExhibition.styleTemplateID,
		defaultLanguage: landingExhibition.defaultLanguage,
		languages: landingExhibition.languages,
		landingArticleID: articleTypes.articleList,
		languageContent: languageContentList.map(([languageISO, title]) => [
			languageISO,
			{ languageISO, title, description: '' },
		]),
		isVirtual: true,
	};
}
function getBaseListArticle(pageTheme, virtualExhibition) {
	return [
		articleTypes.articleList,
		{
			pageTheme,
			id: articleTypes.articleList,
			name: articleTypes.articleList,
			type: articleTypes.articleList,
			languageContent: virtualExhibition.languageContent.map(lc => lc[1]),
			triggers: [],
		},
	];
}
/**
 * This Method creates an exhibition Object by taking basic exhibition informaiton like lanugages
 * ans analyticsSiteId from the landingExhibition and creates article objects out of the glossaryTerms
 *
 * @param { landingExhibition, glossary } params
 */
export function createGlossaryExhibition({ landingExhibition, glossary }) {
	const languageContentList = [
		['de', 'Glossar'],
		['en', 'Glossary'],
	];
	const virtualExhibition = Object.assign(
		getBaseExhibition(landingExhibition, exhibitionTypes.glossary, languageContentList),
		{
			articles: glossary.map(entry => [entry.id, entry]),
		}
	);
	virtualExhibition.articles.push(getBaseListArticle('glossary', virtualExhibition));
	virtualExhibition.articleMap = createObjectFromArray(virtualExhibition.articles);
	return virtualExhibition;
}
/**
 * This Method creates an exhibition Object by taking basic exhibition information like lanugages
 * ans analyticsSiteId from the landingExhibition and creates article objects out of the calendarEvents
 *
 * @param { landingExhibition, calendarEvents } params
 */
export function createCalendarEventsExhibition({ landingExhibition, calendarEvents }) {
	const languageContentList = [
		['de', 'Veranstaltungen'],
		['en', 'Events'],
	];
	const virtualExhibition = Object.assign(
		getBaseExhibition(landingExhibition, exhibitionTypes.calendar, languageContentList),
		{
			articles: calendarEvents.map(entry => [entry.id, entry]),
		}
	);
	virtualExhibition.articles.push(getBaseListArticle('calendar-events', virtualExhibition));
	virtualExhibition.articleMap = createObjectFromArray(virtualExhibition.articles);
	return virtualExhibition;
}

/**
 * This Method creates an exhibition Object by taking basic exhibition information like lanugages
 * ans analyticsSiteId from the landingExhibition and creates article objects out of the calendarEvents
 *
 * @param { } params
 */
export function createRootExhibition({ landingExhibition }) {
	const languageContentList = [
		['de', ''],
		['en', ''],
	];
	const virtualExhibition = Object.assign(
		getBaseExhibition(landingExhibition, exhibitionTypes.root, languageContentList),
		{
			articles: [
				[
					'exhibition-list',
					{
						pageTheme: 'exhibition-list',
						id: 'exhibition-list',
						name: 'exhibition-list',
						type: articleTypes.articleList,
						languageContent: languageContentList.map(lc => lc[1]),
						triggers: [],
					},
				],
				[
					'tour-list',
					{
						pageTheme: 'tour-list',
						id: 'tour-list',
						name: 'tour-list',
						type: articleTypes.articleList,
						languageContent: languageContentList.map(lc => lc[1]),
						triggers: [],
					},
				],
			],
			landingArticleID: 'exhibition-list',
		}
	);
	virtualExhibition.articles.push(getBaseListArticle('calendar-events', virtualExhibition));
	virtualExhibition.articleMap = createObjectFromArray(virtualExhibition.articles);
	return virtualExhibition;
}
